export type SecurityType = {
  id: string;
  name: string;
  orderIndex: number;
};

export const SECURITIES: SecurityType[] = [
  {
    id: 'CVTS',
    name: 'Convertible securities',
    orderIndex: 1,
  },

  {
    id: 'DWHD',
    name: 'Debt with denomination < €100.000',
    orderIndex: 2,
  },
  {
    id: 'DWLD',
    name: 'Debt with denomination ≥ €100.000',
    orderIndex: 3,
  },
  {
    id: 'DLRM',
    name: 'Debt with denomination < €100.000 available only to qualified investors',
    orderIndex: 4,
  },
  {
    id: 'DPRS',
    name: 'Depository receipts',
    orderIndex: 5,
  },
  {
    id: 'ABSE',
    name: 'ABS',
    orderIndex: 6,
  },
  {
    id: 'DERV',
    name: 'Derivative securities',
    orderIndex: 7,
  },
];

export const ORDER_NUMBER = '.orderNumber';
export const CONSIDERATION_EQUAL_FIELD = '.consideration.equal';
export const CONSIDERATION_FROM_FIELD = '.consideration.from';
export const CONSIDERATION_TO_FIELD = '.consideration.to';
export const MEMBER_STATE_ADMISSION_TO_TRADING_FIELD = '.memberStateAdmissionToTrading';
export const TRADING_VENUE_CHARACTERISTICS_FIELD = '.tradingVenueCharacteristics';
export const MEMBER_STATE_OFFER_TO_PUBLIC_FIELD = '.memberStateOfferToPublic';
export const DENOMINATION_PER_UNIT_FIELD = '.denominationPerUnit';
export const UNDERLYING_IDENTIFIER_FIELD = '.underlying.identifier';
export const UNDERLYING_NAME_OR_ISIN_FIELD = '.underlying.nameOrIsin';
export const MATURITY_DATE_FIELD = '.maturityDate';
export const OFFER_END_DATE_FIELD = '.offerEndDate';

export const DENOMINATION_PER_UNIT_CONDITION = /^ITNXXX$/;
export const IDENTIFIER_OR_NAME_OF_UNDERLYING_CONDITION = /^((C[BEFHIMPS])(.?){4}|ITNXXX)$/;
export const MATURITY_OR_EXPIRY_DATE_CONDITION = /^((E[CDFLMPS])(.?){4}|ITNXXX)$/;

export const UNDERLYING_HELP =
  'ISIN code of the underlying security/index or name of the underlying security/index if an ISIN does not exist. \nThis field is only applicable to securities with defined underlying.\n* For unique underlying: \n** select "ISIN" and enter the ISIN (if existing) or,\n** select "Identifier" and chose a value from the list (if no ISIN available). If the name of the underlying is not in the list,\n** select "Name" and enter the name of the underlying.\n* For multiple underlying\'s, select "Basket".';
export const CONSIDERATION_OFFERED_HELP =
  'Total amount offered, in monetary value of the issuance currency (if applicable). Please fill in either:\n* Consideration offered to,\n* Consideration offered from and Consideration offered to,\n* Consideration offered or\n* Select "Pending" in case the Consideration offered is not yet available.';
